import { createSlice } from '@reduxjs/toolkit'

export interface IHallsDataState {
    pagination: {
        itemsPerPage: number
        currentPage: number
        total: number
    }
    searchValue: string | null
    filters?: any
    pureFilters?: any
    sort?: string
    projection?: any
    needPopulate: boolean
    addPresignedURL?: boolean
    populates?: any
}

const initialState: IHallsDataState = {
    pagination: {
        itemsPerPage: 10,
        currentPage: 1,
        total: 0
    },
    searchValue: null,
    filters: {},
    pureFilters: {},
    sort: '-createdAt',
    projection: [],
    needPopulate: true,
    addPresignedURL: true,
    populates: []
}

const hallSlice = createSlice({
    name: 'ui/halls',
    initialState,
    reducers: {
        onChangePagination(state, acion) {
            state.pagination = { ...state.pagination, ...acion.payload }
        },
        onChangeSearch(state, action) {
            state.searchValue = action.payload
        },
        onChangeTotal(state, action) {
            state.pagination = { ...state.pagination, total: action.payload }
        },
        onChangeFilters(state, action) {
            state.filters = action.payload
        },
        onChangePureFilters(state, action) {
            state.pureFilters = action.payload
        },
        addPureFilter(state, action) {
            const objectkeys = Object.keys(action.payload)
            for (const key of objectkeys) {
                state.pureFilters[key] = action.payload[key]
            }
        },
        onResetFilters(state) {
            state.filters = {}
            state.pureFilters = {}
        }
    }
})

export const hallActions = hallSlice.actions
export default hallSlice.reducer
